"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ton = exports.sleep = void 0;
const ton_1 = require("ton");
async function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
exports.sleep = sleep;
class Ton {
    async connect(network) {
        await network.setUp();
        this.sender = network.sender;
        this.api = network.api;
        this.oldApi = network.oldApi;
        const walletAddress = this.sender.address;
        if (!(await network.isContractDeployed(walletAddress))) {
            throw "wallet is not deployed";
        }
        return this;
    }
    async internalMessage(provider, coins, body, sendMode = ton_1.SendMode.PAY_GAS_SEPARATELY) {
        await this.wait(async () => {
            await provider.internal(this.sender, {
                value: `${coins.toFixed(2)}`,
                body,
                sendMode,
            });
        });
    }
    async wait(callback) {
        if (!this.api) {
            return await callback();
        }
        const seqno = (await this.api.getLastBlock()).last.seqno;
        const result = await callback();
        // wait until confirmed
        let currentSeqno = seqno;
        while (currentSeqno == seqno) {
            console.log("waiting for transaction to confirm...");
            await sleep(1500);
            currentSeqno = (await this.api.getLastBlock()).last.seqno;
        }
        console.log("transaction confirmed!");
        return result;
    }
}
exports.Ton = Ton;
//# sourceMappingURL=Ton.js.map